/**
 * Dictation feature constants.
 */

/**
 * Geometry shared by every mic-button state and by the placeholder the composer
 * renders while the lazy button loads — they must not drift apart. Deliberately
 * smaller than the send button, which owns the primary action.
 */
export const MIC_BUTTON_CLASS = 'size-[30px] rounded-full';

/** Delay before auto-prefetching token (don't block initial render) */
export const TOKEN_PREFETCH_DELAY_MS = 1000;

/** Wait for VAD to send final transcript before closing connection */
export const VAD_FINAL_TRANSCRIPT_DELAY_MS = 300;

/** Total attempts (1 initial + 1 retry) when fetching an ElevenLabs token. */
export const TOKEN_FETCH_MAX_ATTEMPTS = 2;

/** Backoff between token-fetch retries (ms). */
export const TOKEN_FETCH_RETRY_BACKOFF_MS = 150;

/** Disable dictation when message is at this percentage of max length (92%) */
export const DICTATION_DISABLE_THRESHOLD_PERCENT = 0.92;

/** Delay for browser to release microphone hardware after stream.stop() */
export const MIC_RELEASE_DELAY_MS = 200;

/** Duration to show tooltip before auto-hiding */
export const TOOLTIP_AUTO_HIDE_DURATION_MS = 3000;

/**
 * Adapter-internal error identifiers emitted via `setDictationErrorType`. These
 * label failure paths that don't have a matching provider event name, so they
 * appear on the `dictation_error` analytics event's `errorType` property.
 * Provider-native codes (e.g. ElevenLabs `QUOTA_EXCEEDED`, Web Speech API
 * `not-allowed`) are passed through as-is.
 */
export const DICTATION_ERROR_TYPE = {
  TOKEN_FETCH: 'TOKEN_FETCH',
  CONNECTION_CLOSED_BEFORE_START: 'CONNECTION_CLOSED_BEFORE_START',
  START_FAILED: 'START_FAILED',
  UNKNOWN: 'UNKNOWN',
} as const;
